// extracted by mini-css-extract-plugin
export default {"tabs_container":"index__tabs_container__tNmtB","tabsContainer":"index__tabs_container__tNmtB","tab_selected":"index__tab_selected__Zxxx1","tabSelected":"index__tab_selected__Zxxx1"};